module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel202309_05_1280_1280_ja-1c4a871788c31e3b273de009a8ddbd9f.jpg";